<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html {
  overflow-y: auto;
  overscroll-behavior-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow: hidden;
}
body {
  background-color: #f4f4f4;
  margin: 0;
  font-family: "Hiragino Mincho ProN";
  overflow: hidden;
}
.super {
  max-width: 639px;
  background-color: #f4f4f4;
  padding: 0;
  margin: auto;
  position: relative;
}
p {
  margin: 0;
}
button {
  border: none;
}
h1,
h2,
h3 {
  margin: 0;
  font-weight: normal;
}
h3 {
  font-size: 13px;
}
a {
  text-decoration: none;
}
ul,
li {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: top;
}
div {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue